import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AlertComponent } from '../../common/alert/alert.component';
import { PlatformComponent } from '../../models/workflow/Model.model';
import { GlobalService } from '../../services/global.service';
import { WorkflowService } from '../../services/workflow-service';

@Component({
  selector: 'app-send-data',
  templateUrl: './send-data.component.html',
  styleUrls: ['./send-data.component.css']
})
export class SendDataComponent implements OnInit {
  componentDetails: PlatformComponent = new PlatformComponent();
  isLoading = false;
  readOnly: false;
  dataSourceList: any;
  
  public sendDataForm = new UntypedFormGroup({
    id: new UntypedFormControl(''),
    dataSourceId: new UntypedFormControl({ value: '', disabled: false }, Validators.required)
  });

  constructor(public dialogRef: MatDialogRef<SendDataComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public sendDataService: WorkflowService,
    public dialog: MatDialog,
    public globalService: GlobalService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.getListDataSource();
    this.componentDetails = this.data.component;
    this.readOnly = this.data.readOnly;
    this.sendDataForm.patchValue({ dataSourceId: this.componentDetails.componentDetails.id });
  }

  getListDataSource() {
    this.sendDataService.getListDataSource().subscribe((data) => {
      this.dataSourceList = data['dataSourceList'];
      this.isLoading = false;
    }, (error: Error) => {
      this.globalService.showAlert(AlertComponent, { success: false, message: "Something went wrong!" });
      this.isLoading = false;
    });
  }

  disableSave() {
    let check: boolean;
    check = this.readOnly || !this.sendDataForm.valid;
    return check;
  }

  savesendDataSpecifications() {
    this.data.component.componentDetails.id = this.sendDataForm.get('dataSourceId').value;
    this.data.component.componentDetails.name = this.dataSourceList.find((item: any) => item.datasourceId == this.data.component.componentDetails.id).datasourceName;
    this.dialogRef.close(false);
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }

}
